import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

//Components
import Loading from '../../../components/Loading/Loading';
import MainCard from '../../../components/MainCard/MainCard';
import RelatorioCertificadoBalancaMassa from './RelatorioCertificadoBalancaMassa';

//Helpers
import { objCampo } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from 'helpers/message';

//Api
import relatorio_api from '../../../api/relatorio_api';
import TextField from '../../../components/TextField/TextField';

function initialStateFiltros() {
    return {
        mesAno: "",
        nomeRelatorio: "Relatórios - Certificado de Balanço de Massa"
    }
}

export default function CertificadoBalancaMassa() {
    //Estado que guarda os valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros());

    const [selectedDate, setSelectedDate] = useState('');

    const handleDateChange = (date) => {
        if (date && date.isValid()) {
            const month = date.format('MM');
            const year = date.format('YYYY');
            setFiltros({
                ...filtros,
                mesAno: `${month}/${year}`
            });
        }
        setSelectedDate(date);
    };

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState();

    //Estado que guarda os dados do relatorio
    const [dadosRelatorio, setDadosRelatorio] = useState(null);

    //Variavel de navegação na tela
    const navigate = useNavigate();

    const carregarRelatorio = () => {
        if(filtros.mesAno.length == 0){
            showMessage("Aviso", "Por favor, selecione o Mês/Ano.", "warning", null);
            return;
        }
       
        setLoading(true);
        relatorio_api.CertificadoBalancoMassa(filtros)
            .then(response => {

                setDadosRelatorio(response.data);
            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    if (dadosRelatorio != null) {
        return <RelatorioCertificadoBalancaMassa
            dadosRelatorio={dadosRelatorio}
            btnVoltar={() => {
                setDadosRelatorio(null)
                setSelectedDate('')
                setFiltros(initialStateFiltros())
            }}
            filtros={filtros} />
    }

    return (
        <MainCard btnVoltarInTop={() => navigate(-1)}>
            {loading && <Loading />}
            <h4>Relatório Certificado de balanço de massa</h4>
            <Row sm="12" md="6" lg="4">
                <Col sm="12" md="6" lg="3">
                   <TextField
                        label={"*Mês/Ano"}
                        type="monthYear"
                        onChange={handleDateChange}
                        value={selectedDate}
                   />
                </Col>
                <Col sm="12" md="6" lg="3" style={{ marginTop: "1.875rem" }}>
                    <Button
                        className='w-100 fw-bold'
                        color='info text-light'
                        onClick={carregarRelatorio}>Gerar Relatório</Button>
                </Col>
            </Row>
        </MainCard>
    );
}

